/**
 * カート工事情報入力。可変ファイル欄は x-file-manager の `file_status` を利用する。
 * 定数は `resources/js/enums/file-manager-file-status.js`（PHP: `App\Enums\FileManagerFileStatus`）と揃える。
 */
(function bootstrapCartInstallationPage() {
    const installationTypeSelect = document.getElementById('installation_type');
    if (!(installationTypeSelect instanceof HTMLSelectElement)) {
        return;
    }

    const installationTypeRows = document.querySelectorAll('[data-installation-type-row]');

    function applyInstallationTypeUi() {
        const currentInstallationType = installationTypeSelect.value;

        installationTypeRows.forEach((row) => {
            const rawVisibleTypes = row.getAttribute('data-visible-installation-types') ?? '';
            const visibleInstallationTypes = rawVisibleTypes.split(',').filter((token) => token !== '');
            if (visibleInstallationTypes.length === 0) {
                return;
            }
            row.classList.toggle('d-none', !visibleInstallationTypes.includes(currentInstallationType));
        });
    }

    installationTypeSelect.addEventListener('change', applyInstallationTypeUi);
    applyInstallationTypeUi();
})();
